import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.parse-float.js";
import { request } from "@/js/http/http_request";
import { getSymbolCurrency } from "@/js/currency/currencies.js";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import { expeditionMethods } from "@/js/lists.ts";
export default {
  name: "EditOrderItemPriceDialog",
  props: {
    item: {
      type: Object
    }
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        width: 400,
        zIndex: 2000
      },
      priceLabel: "Price per bottle",
      form: {
        itemId: null,
        price: 0.0,
        isStoredAtCellar: false
      },
      initialPrice: 0.0,
      isSaving: false,
      rules: formRules
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var _this2 = this;
      var nullishPredicate = function nullishPredicate(x) {
        return parseFloat(x.price) < 0 || x.price == _this2.initialPrice;
      };
      if (nullishPredicate(this.form)) return true;
      return false;
    }
  },
  created: function created() {
    if (this.item) {
      var IsStoredAtCellar = this.item.expeditionMethod === expeditionMethods.CELLAR_STORAGE.id;
      var unitPrice = IsStoredAtCellar ? this.item.unit_price_currency : this.item.unitPriceIncludeDefaultShippingCurrency;
      this.priceLabel += " (" + getSymbolCurrency(this.item.currency) + ")";
      this.form.itemId = this.item.id_item;
      this.form.price = unitPrice;
      this.form.isStoredAtCellar = IsStoredAtCellar;
      this.initialPrice = unitPrice;
    }
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this3.isSaving = true;
              _this = _this3;
              _context.next = 4;
              return request("/v1/order/item/price", "post", _this3.form, true, "api").then(function (_) {
                _this.isSaving = false;
                _this.$toasted.show("Price successfully updated.", {
                  type: "success"
                });
                _this.$emit("confirmed");
              }).catch(function (e) {
                _this.isSaving = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the new price.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    revertToDefaultPrice: function revertToDefaultPrice() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isSaving = true;
              _this = _this4;
              _context2.next = 4;
              return request("/v1/order/item/reset-price", "post", {
                itemId: _this4.item.id_item
              }, true, "api").then(function (_) {
                _this.isSaving = false;
                _this.$toasted.show("Price successfully reverted.", {
                  type: "success"
                });
                _this.$emit("confirmed");
              }).catch(function (e) {
                _this.isSaving = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to revert the price.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    filterDecimal2digitsKey: filterDecimal2digitsKey
  }
};